import React, { FC, useState, useEffect } from 'react';
import { BreakpointsInPx } from '../../../../constants/breakpoints.constants';
import useMediaQuery from '../../../../lib/custom-hooks/useMediaQuery';
import VideoPlayer from '../../../@shared/videoPlayer';
import Picture from '../../../@shared/picture';
import { THeroCardProps } from '../../types/heroCard.types';
import { TContentHubImageProps } from '../../../@shared/picture/types/contentHubImage.types';

// This component has different purpose than the carouselCard in overlaycarosuelpopup shared component
const HeroCard: FC<THeroCardProps> = ({ slide, playCallback, pauseCallback, endCallback, activeCard, moveLeft, moveRight, index }) => {
  const isWide = useMediaQuery(`(min-width: ${BreakpointsInPx.md})`);
  const [swipeStart, setSwipeStart] = useState(0);

  useEffect(() => {
    setSwipeStart(0);
  }, [activeCard, index]);

  const handleTouchStartVideoPlay = (event): void => {
    if (isWide) return;
    const value = event?.changedTouches?.[0]?.pageX;
    if (!value) return;
    setSwipeStart(value);
  };

  const handleTouchEndVideoPlay = (event): void => {
    if (isWide) return;
    const value = event?.changedTouches?.[0]?.pageX;
    if (!value) {
      setSwipeStart(0);
      return;
    }

    if (value < swipeStart && swipeStart - value > 20) {
      if (moveRight) moveRight();
    } else if (value > swipeStart && value - swipeStart > 20) {
      if (moveLeft) moveLeft();
    }
    setSwipeStart(0);
  };

  const productImageProps: TContentHubImageProps = {
    desktopRendition: slide.rendition_desktop_size1200,
    mobileRendition: slide.rendition_mobile_size500,
    alt: slide.alt,
    onTouchStart: handleTouchStartVideoPlay,
    onTouchEnd: handleTouchEndVideoPlay,
    isVideoThumbnail: slide.isVideo,
    pictureClassName: 'series-overview-hero-card__picture',
  };

  return (
    <>
      <div className="series-overview-carousel__slide-wrapper">
        {slide.isVideo ? (
          <div className="series-overview-hero-card__focus-image">
            <VideoPlayer
              className="series-overview-modal-video"
              link={slide.full}
              autoPlay={true}
              showThumbnail={true}
              muted={!isWide}
              playCallback={playCallback}
              pauseCallback={pauseCallback}
              endCallback={endCallback}
              productImageProps={productImageProps}
            />
          </div>
        ) : (
          <Picture productImageProps={productImageProps} />
        )}
      </div>
    </>
  );
};

export default React.memo(HeroCard);
